import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GeocodingService {

  geocodeAddress(address: string): Observable<google.maps.GeocoderResult[]> {
    return new Observable(observer => {
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address }, (results, status) => {
        if (status === 'OK' && results) {
          observer.next(results);
          observer.complete();
        } else {
          observer.error(`Geocode error: ${status}`);
        }
      });
    });
  }
}
